import { render, staticRenderFns } from "./Bodyer.vue?vue&type=template&id=325135aa&"
import script from "./Bodyer.vue?vue&type=script&lang=js&"
export * from "./Bodyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports